module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/valet-icon-6835581a5524359f410acbbcc0ca2114.png";